import { call, delay, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { exportAnalysis, getAnalysis } from 'api/comparative-analysis';
import { SagaPayload } from 'types';
import { AxiosResponse } from 'axios';
import { Params } from './type';
import { requestTransits, getTransitsSuccess, exportSuccess, exportError, requestExport } from './slice';

export function* wimTransitsAnalysisRequestSaga({ payload }: SagaPayload<Params>) {
  const res: AxiosResponse<any> = yield call(getAnalysis, payload);
  yield put(getTransitsSuccess(res));
}

export function* exportAnalysisRequestSaga({ payload }: SagaPayload<Params>) {
  try {
    const res: AxiosResponse<any> = yield call(exportAnalysis, payload);
    if (res) {
      // const url = window.URL.createObjectURL(new Blob([res.data]));
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', `analysis.${payload.format}`);
      // document.body.appendChild(links);
      // link.click();
      // link.remove();
      yield put(exportSuccess(res.data));
    } else {
      yield put(exportError(res));
    }
  } catch (error: any) {
    yield put(exportError(error.message));
  }
}
export function* wimTransitsAnalysisRequestWatchSaga() {
  yield takeLatest(requestTransits, wimTransitsAnalysisRequestSaga);
}

export function* exportAnalysisRequestWatchSaga() {
  yield takeEvery(requestExport, exportAnalysisRequestSaga);
}
